import { FC, Fragment, useLayoutEffect } from "react";
import { GALLERY } from "./LoveLineGallery.const";
import "./LoveLineGallery.style.scss";

export const LoveLineGallery: FC = () => {
  useLayoutEffect(() => {
    // @ts-ignore
    $(".timeline-gallery").owlCarousel({
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
      },
    });
  }, []);

  return (
    <Fragment>
      <div
        className="year"
        data-animation-direction="from-top"
        data-animation-delay="250"
      >
        <span className="neela-style" style={{ fontWeight: 300 }}>
          <span className="h-lines"></span>
          <span className="v-lines"></span>2021 - 2024
        </span>
      </div>

      <div className="gallery-container">
        <div
          className="timeline-gallery-wrapper"
          data-animation-direction="from-left"
          data-animation-delay="250"
        >
          <div className="timeline-gallery owl-carousel">
            {GALLERY.map(({ image, thumb }) => {
              return (
                <div className="item" key={image}>
                  <a
                    className="hover-img"
                    href={image}
                    data-lightbox="gallery-timeline"
                  >
                    <span className="btn btn-light btn-sm">
                      <span className="h-lines"></span>
                      <span className="v-lines"></span>+
                    </span>
                  </a>
                  <img src={thumb} alt="" />
                </div>
              );
            })}
          </div>
        </div>

        <div
          className="description-wrapper"
          data-animation-direction="from-bottom"
          data-animation-delay="250"
        >
          <div className="description">
            <div className="neela-style">
              <span className="h-lines"></span>
              <span className="v-lines"></span>
              <h4 style={{ fontWeight: 300 }}>
                Some of our most memorable moments
              </h4>
              <p>
                These are the moments that have shaped our journey together - the
                laughter, the adventures, and the quiet times that brought us
                closer. From our first unexpected date to countless road trips,
                sunsets, and shared dreams, each memory is a beautiful piece of
                our story.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
